export const TOP_GLOBAL_COUNTRY_CODES = ['ca', 'gb', 'us'];
